import request from '@/utils/request'
// 咨询列表
export function ConsultaionList(data) {
    return request({
        url:'/netbar/api/professional_consultation/v1/get_list',
        method:'post',
        data
    })
}
// 咨询详情
export function ConsultaionDetails(data) {
    return request({
        url:'/netbar/api/professional_consultation/v1/get_detail',
        method:'post',
        data
    })
}
// 新建咨询
export function ConsultaionSave(data) {
    return request({
        url:'/netbar/api/professional_consultation/v1/save',
        method:'post',
        data
    })
}
// 获取网吧信息
export function ConsultaionInfo(data) {
    return request({
        url:'/netbar/api/user/v1/belong_netbar',
        method:'post',
        data
    })
}
// 咨询类型
export function ConsultaionType(data) {
    return request({
        url:'/netbar/api/professional_consultation/v1/get_type_list',
        method:'post',
        data
    })
}